function breakHtmlForCamelCase(str: string): string {
  return wrapWordBrokenHtml(breakCamelCase(str));
}

function breakHtmlForSlash(str: string): string {
  return wrapWordBrokenHtml(breakForSlash(str));
}

function breakHtmlForPeriod(str: string): string {
  return wrapWordBrokenHtml(breakPeriod(str));
}

function breakHtmlForUnderscore(str: string): string {
  return wrapWordBrokenHtml(breakUnderscore(str));
}

function breakHtmlForDoubleColon(str: string): string {
  return wrapWordBrokenHtml(breakDoubleColon(str));
}

function breakHtmlForWhitespace(str: string): string {
  return wrapWordBrokenHtml(breakWhiteSpace(str));
}

function breakHtmlForAll(str: string): string {
  return wrapWordBrokenHtml(
    [
      breakCamelCase,
      breakPeriod,
      breakUnderscore,
      breakDoubleColon,
      breakWhiteSpace,
      breakForSlash,
    ].reduce((brokenStr, breakFn) => breakFn(brokenStr), str)
  );
}

// Place a word break between a lower and upper case character
function breakCamelCase(str: string): string {
  return str.replace(/([a-z])([A-Z])/g, '$1<wbr>$2');
}

function breakForSlash(str: string): string {
  return removeBreakAtFront(str.replace(/\/(?=\S)/g, '<wbr>/'));
}

// Place a break before `.`
function breakPeriod(str: string): string {
  // Regex: Any period that has non-whitespace before and after it
  return removeBreakAtFront(str.replace(/\.(?=\S)/g, '<wbr>.'));
}

// Place a break before `_`
function breakUnderscore(str: string): string {
  // Regex: Any underscore that has non-whitespace before and after it
  return removeBreakAtFront(str.replace(/_(?=\S)/g, '<wbr>_'));
}

// Place a break before `::`
function breakDoubleColon(str: string): string {
  // Regex: Any double colon that has non-whitespace before and after it
  return removeBreakAtFront(str.replace(/::(?=\S)/g, '<wbr>::'));
}

// Replace all continuous whitespace with a break and space
function breakWhiteSpace(str: string): string {
  // Regex: Any whitespace that has non-whitespace after it
  return removeBreakAtFront(str.replace(/\s+(?=\S)/g, '<wbr> '));
}

// This is needed because some JS envs don't yet support
// lookbehind in regex.
function removeBreakAtFront(str: string): string {
  if (str.indexOf('<wbr>') === 0) {
    return str.slice(5);
  } else {
    return str;
  }
}

function wrapWordBrokenHtml(str: string): string {
  return `<span style="word-break: break-word">${str}</span>`;
}

export {
  breakHtmlForAll,
  breakHtmlForCamelCase,
  breakHtmlForSlash,
  breakHtmlForPeriod,
  breakHtmlForUnderscore,
  breakHtmlForDoubleColon,
  breakHtmlForWhitespace,
};
